import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AppProvider } from "./context/AppContext";
import ErrorBoundary from "./components/ErrorBoundary";
import App from "./App";

/**
 * Top-level router shell.
 *
 * During migration the catch-all "*" route renders the legacy App
 * component (which still uses activeTab internally). As screens are
 * converted to proper routes they get added above the catch-all.
 */
export default function AppRouter() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <AppProvider>
          <Routes>
            {/* ── Migrated routes will be added here ──────────── */}

            {/* ── Legacy catch-all ─────────────────────────────── */}
            <Route path="*" element={<App />} />
          </Routes>
        </AppProvider>
      </BrowserRouter>
    </ErrorBoundary>
  );
}
